import {
  Editor,
  isPageId,
  pageIdValidator,
  RecordProps,
  T,
  TLArrowShape,
  TLBaseShape,
  TLImageShape,
  TLPageId,
} from "tldraw"
import { CloneOptions, CustomDrawShape } from "./CustomDrawShape"
import { StickerShape } from "./StickerShape"
import { LDGeoShape } from "./LDGeoShape"
import { LDTextShape } from "./LDTextShape"
import { Env, Expr } from "./Expr"
import { LayerId } from "./Layer"
import { LDLineShape } from "./LDLineShape"

/** Meta for tldraw shapes (not fully customized) */
type BaseShapeMeta = {
  layer: string
}

type LDGroupShapeProps = {
  layer: LayerId
  // source page for the sticker
  pageId: TLPageId
  parameterValues: Env
  clone?: CloneOptions
  isClone?: boolean
}

export type LDArrowShape = Omit<TLArrowShape, "meta"> & { meta: BaseShapeMeta }
export type LDImageShape = Omit<TLImageShape, "meta"> & { meta: BaseShapeMeta }
export type LDGroupShape = Omit<
  TLBaseShape<"custom-group", LDGroupShapeProps>,
  "meta"
> & { meta: {} }

/** All of the shapes supported by LiveDraw */
export type LDShape =
  | LDArrowShape
  | LDTextShape
  | LDImageShape
  | CustomDrawShape
  | StickerShape
  | LDGeoShape
  | LDGroupShape
  | LDLineShape

export namespace LDShape {
  /** Gets the layer from a shape, either from meta or props depending if it's a built-in Tldraw shape or a custom LiveDraw shape  */
  export function getLayerId(shape: LDShape): string {
    switch (shape.type) {
      case "arrow":
      case "image":
        return shape.meta.layer
    }
    return shape.props.layer
  }

  export function getSourcePageId(editor: Editor, s: LDShape): TLPageId {
    if (isPageId(s.parentId)) {
      return s.parentId
    }
    // parent must be a group
    const groupShape = editor.getShape(s.parentId) as LDGroupShape

    return groupShape.props.pageId
  }
}

/** @public */
export const ldGroupShapeProps: RecordProps<LDGroupShape> = {
  pageId: pageIdValidator,
  layer: T.string.refine((v) => v as LayerId),
  parameterValues: T.any,
  clone: T.any,
  isClone: T.any,
}
